// The signed-in user's email, read synchronously from the session the same
// way useCurrentUser() does internally, without a GET /staff/me round-trip.
// Used only to decide what a screen OFFERS (a director's picker, a "(you)"
// label); the backend stays authoritative about what is allowed.
// Moved out of TimeEntryForm (BM-H3749) so the All My Time Entries page can
// use the same read instead of a second copy.
export function currentUserEmail() {
  if (typeof window === "undefined") return "";
  return (
    sessionStorage.getItem("bonsai_user_email") ||
    localStorage.getItem("bonsai_user_email") ||
    sessionStorage.getItem("bonsai_user_id") ||
    ""
  ).toLowerCase();
}
